import SettingUtils from 'shared/utils/settings'

export default function getBrandingColor () {
  const options = window.booqableOptions

  return options?.primaryColor?.length ? options.primaryColor : SettingUtils.get('store.brand_color')
}
